<template>
  <div class="container">
    <div class="box">
      <h1 class="title">Welcome to Plastic Collections</h1>

      <p>
        If you have any questions, please do not hesitate to
        call the Delta Plastics Information Systems team.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Landing'
}
</script>
